<template>
  <div class="quiz-chapter-name-container">
    <div class="quiz-chapter-name-wrapper container-sm">
      <div class="quiz-chapter-name">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'quiz-chapter-name',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/styles/components/_typographies';

  .quiz-chapter-name-container {
    background: #ffffff;
    height: 60px;

    .quiz-chapter-name-wrapper {
      padding: 15px 16px 15px 16px;
      border-bottom: 1px solid #f0f0f0;

      .quiz-chapter-name {
        @extend .typography-headline-6;
        opacity: 0.87;
        color: #353535;
      }
    }
  }
</style>
